import { ref } from 'vue'
import store from '@/store'
import { config } from '@/config'
import { useToast } from '@/composables/common/useToast'

export function useSendForReview(endpointAlias, refreshCallback = () => {}) {
    const toast = useToast()

    const showModal = ref(false)
    const sending = ref(false)
    const selectedLiquidacionId = ref(null)
    const observaciones = ref('')

    function open(liquidacion = {}) {
        selectedLiquidacionId.value = liquidacion.id || null
        observaciones.value = liquidacion.observaciones || ''
        showModal.value = true
    }

    function close() {
        showModal.value = false
        selectedLiquidacionId.value = null
        observaciones.value = ''
    }

    async function submit(nextObservaciones) {
        if (!selectedLiquidacionId.value || sending.value) {
            return
        }

        const params = {
            liquidacion_id: selectedLiquidacionId.value
        }

        if (nextObservaciones) {
            params.observaciones = nextObservaciones
        }

        sending.value = true

        try {
            const response = await store.dispatch(config.getVuexAlias(endpointAlias), params)
            toast.success(response.data.message)
            close()
            await refreshCallback()
        } catch (error) {
            toast.error(error.response?.data?.message || 'No se ha podido solicitar la liquidación')
            throw error
        } finally {
            sending.value = false
        }
    }

    return {
        showModal,
        sending,
        observaciones,
        open,
        close,
        submit,
    }
}
